import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import { getDimensionStyle, getFontStyle } from 'components/patterns/dimensions'

const withStyle = (Component) =>
  styled(Component)((props) => {
    // Why isn't defaultProps working in Storybook? Button is fine...
    const {
      size = 'default',
      doMargins = false,
      doHeight = false,
      theme,
      weight = '',
      horizontalMargins,
      verticalMargins,
      contrast = false,
      theme: { color },
      bold = false,
      italic = false,
    } = props

    // Not a boxed element, so no height.
    const dim = getDimensionStyle({
      size,
      doMargins,
      theme,
      verticalMargins,
      horizontalMargins,
      doHeight,
    })

    const font = getFontStyle(theme)
    const fontColor = color[props.color] || props.color || theme.paragraphColor

    return `
        ${dim}
        ${font}
        ${stylesIf(weight, `font-weight: ${weight};`)};
        ${stylesIf(!contrast, `color: ${fontColor};`)}
        ${stylesIf(contrast, `color: ${theme.paragraphContrastColor};`)}
        ${stylesIf(italic, 'font-style: italic;')}
        ${stylesIf(bold, 'font-weight: bold;')}
      `
  })

export default withStyle
